export const isSettingsGeneticsSection = () => {
  const pathname = window.location.pathname;
  return pathname.replace(/\/$/, '') === '/genetics/setup';
};

export const isClientsSection = () => {
  const pathname = window.location.pathname;
  return pathname.replace(/\/$/, '') === '/clients';
};